<template>
    <tr class="text-muted">
        <td style="vertical-align: middle; text-align:center">
            {{ nippouItem.activity_name }}
        </td>
        <td>
            {{ nippouItem.description }} 
            <button type="button" @click="deleteItem('nippouItem')" class="btn btn-sm btn-link text-danger float-right">
                <i class="fas fa-trash"></i>
            </button>
            <hr class="mt-1 mb-1">
            <b-form-row>
                <b-col sm="2" class="text-right">
                    <label class="text-muted text-sm">詳細</label>
                </b-col>
                <b-col>
                    <input type="text" 
                           class="form-control form-control-sm bg-white"
                           v-model="nippouItem.details"
                           @blur="changed()" 
                           :disabled="disabled">
                </b-col>
            </b-form-row>
        </td>
        <td style="vertical-align: middle; text-align:center">
            <b-form-input type="number" 
                          v-model="nippouItem.time" 
                          @change="changed()" 
                          style="max-width: 100px"
                          class="text-right bg-white"
                          :disabled="disabled" 
                          size="sm" min="0" step="0.01">
            </b-form-input>
        </td>
        <!-- <td>
            <div v-b-modal="'commentModal'+nippouItem.id" class="text-right" style="cursor: pointer">
                <i class="fas fa-plus-circle text-primary"></i> コメント
            </div>
            <div v-for="comment in nippouItem.comments" :key="comment.id" v-b-modal="'commentModal'+nippouItem.id">
                <small class="text-muted">{{comment.user_name}}:</small>
                <span class="text-info">{{comment.text}}</span>
            </div>

            <b-modal :id="'commentModal'+nippouItem.id" hide-footer v-model="showModal" title="コメント" >
                <comment :id="nippouItem.id" 
                        model-class="App\NippouItem"
                        @change="changed()" >
                </comment>
            </b-modal>
        </td> -->
    </tr>
</template>

<script>
    export default {
        props: {
            nippouItem: {
                default: function(){ 
                    return {
                        id: null,
                        description: null,
                        contents: null,
                        time: 0,
                        details: null,
                        comments: [],
                        activity_name: null,
                        activity: {id:null,description:null}
                    }
                }
            },
            disabled: {default:false}
        },
        data: function () {
            return {
                showModal: false
            }
        },
        methods: {
            changed: function () {
                this.showModal = false
                this.$emit('change',this.nippouItem)
            },
            deleteItem: function (item) {
                console.log('delete')
                if(confirm('削除しますか？')) {
                    this.$emit('delete',this.nippouItem)
                }
            }
        },
        beforeCreate() {
        },
        mounted() {
        }
    }
</script>
